(function () {
  if (window.ksNotifyEngineInit) return;
  window.ksNotifyEngineInit = true;

  const popup = document.getElementById('KsNotifyPopup');
  if (!popup) return;

  const form = document.getElementById('KsNotifyPopupForm');
  const titleEl = document.getElementById('KsNotifyPopupProductTitle');
  const imageEl = document.getElementById('KsNotifyPopupImage');
  const imageWrapEl = document.getElementById('KsNotifyPopupImageWrap');
  const handleEl = document.getElementById('KsNotifyPopupHandle');
  const productIdEl = document.getElementById('KsNotifyPopupProductId');
  const productNameEl = document.getElementById('KsNotifyPopupProductName');
  const emailEl = document.getElementById('KsNotifyPopupEmail');
  const messageEl = document.getElementById('KsNotifyPopupMessage');

  let productCache = null;
  let refreshTimer = null;
  let watchersBound = false;
  let lastFocusedElement = null;
  const disabledVariantSelector = '.variant-input.disabled label, .variant-input-wrap input:disabled + label, .product-form__input input[disabled] + label, .product-form__input .disabled + label, .product-form__input label.disabled';

  function getProductHandleFromUrl() {
    try {
      const match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  async function getProductData(handle) {
    if (!handle) return null;

    if (productCache && productCache.handle === handle) {
      return productCache;
    }

    try {
      const res = await fetch('/products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      });

      if (!res.ok) return null;

      const product = await res.json();
      productCache = product;
      return product;
    } catch (e) {
      return null;
    }
  }

  function getProductForm() {
    return (
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-single__form') ||
      document.querySelector('.product-form')
    );
  }

  function getVariantIdInput() {
    const formEl = getProductForm();
    if (!formEl) return null;
    return formEl.querySelector('input[name="id"], select[name="id"], [data-product-select]');
  }

  function getCurrentVariantId() {
    const input = getVariantIdInput();
    return input ? String(input.value || '').trim() : '';
  }

  function getAddToCartButton() {
    const formEl = getProductForm();
    if (!formEl) return null;

    return (
      formEl.querySelector('button[name="add"]') ||
      formEl.querySelector('[data-add-to-cart]') ||
      formEl.querySelector('.product-form__cart-submit') ||
      formEl.querySelector('.add-to-cart')
    );
  }

  function getDynamicCheckout() {
    const formEl = getProductForm();
    if (!formEl) return null;

    return (
      formEl.querySelector('.shopify-payment-button') ||
      formEl.querySelector('[data-shopify="payment-button"]')
    );
  }

  function getNotifyButton() {
    return document.getElementById('ks-notify-inline-trigger');
  }

  function getVariantBlock() {
    return (
      document.querySelector('.product-block[data-dynamic-variants-enabled]') ||
      document.querySelector('.product-block .variant-wrapper')?.closest('.product-block') ||
      document.querySelector('.product-block')
    );
  }

  function ensureNotifyHint() {
    let hint = document.getElementById('ks-notify-variant-hint');
    const hasUnavailableOptions = document.querySelector(disabledVariantSelector) !== null;

    if (!hasUnavailableOptions) {
      if (hint) hint.hidden = true;
      return null;
    }

    if (hint) return hint;

    const variantBlock =
      document.querySelector('.product-block[data-dynamic-variants-enabled]') ||
      document.querySelector('.variant-wrapper')?.closest('.product-block') ||
      document.querySelector('.product-form__input')?.closest('.product-block');

    if (!variantBlock) return null;

    hint = document.createElement('div');
    hint.id = 'ks-notify-variant-hint';
    hint.className = 'ks-notify-variant-hint';
    hint.innerHTML = 'Nicht deine Größe verfügbar? <strong>Klicke auf eine ausverkaufte Größe</strong> und lass dich benachrichtigen.';

    variantBlock.appendChild(hint);
    return hint;
  }

  function ensureNotifyButton() {
    let button = getNotifyButton();
    if (button) return button;

    const formEl = getProductForm();
    const atcButton = getAddToCartButton();
    if (!formEl) return null;

    button = document.createElement('button');
    button.type = 'button';
    button.id = 'ks-notify-inline-trigger';
    button.className = 'ks-notify-inline-trigger';
    button.hidden = true;
    button.textContent = 'Benachrichtigen, wenn verfügbar';

    if (atcButton && atcButton.parentNode) {
      atcButton.parentNode.insertBefore(button, atcButton.nextSibling);
    } else {
      formEl.appendChild(button);
    }

    return button;
  }

  function prepareDisabledVariantLabels() {
    document.querySelectorAll(disabledVariantSelector).forEach(function (label) {
      const optionName = String(label.textContent || '').trim();

      label.tabIndex = 0;
      label.setAttribute('role', 'button');
      label.setAttribute(
        'aria-label',
        (optionName ? optionName + ' ist nicht verfügbar. ' : '') + 'Benachrichtigung anfordern'
      );
    });
  }

  function normalizeValue(value) {
    return String(value || '').trim();
  }

  function getVariantDescriptor(variant) {
    if (!variant) return '';

    if (variant.options && variant.options.length) {
      const optionValues = variant.options.filter(function (value) {
        return value && normalizeValue(value).toLowerCase() !== 'default title';
      });

      if (optionValues.length) {
        return optionValues.join(' / ');
      }
    }

    if (variant.title && variant.title !== 'Default Title') {
      return variant.title;
    }

    return '';
  }

  function buildMessage(productTitle, variant) {
    const descriptor = getVariantDescriptor(variant);

    if (descriptor) {
      return 'Bitte benachrichtigt mich, sobald dieser Artikel wieder verfügbar ist: ' + productTitle + ' – Variante/Größe: ' + descriptor;
    }

    return 'Bitte benachrichtigt mich, sobald dieser Artikel wieder verfügbar ist: ' + productTitle;
  }

  function openPopup(data) {
    const title = data.title || '';
    const handle = data.handle || '';
    const productId = data.productId || '';
    const image = data.image || '';
    const variant = data.variant || null;

    if (titleEl) {
      const descriptor = getVariantDescriptor(variant);
      titleEl.textContent = descriptor ? title + ' – ' + descriptor : title;
    }

    if (handleEl) handleEl.value = handle;
    if (productIdEl) productIdEl.value = productId;
    if (productNameEl) productNameEl.value = title;

    if (messageEl) {
      messageEl.value = buildMessage(title, variant);
    }

    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    if (imageEl && imageWrapEl) {
      if (image) {
        imageEl.src = image;
        imageEl.alt = title;
        imageWrapEl.hidden = false;
      } else {
        imageEl.removeAttribute('src');
        imageEl.alt = '';
        imageWrapEl.hidden = true;
      }
    }

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ks-notify-popup-open');
    document.body.classList.add('ks-notify-popup-open');

    window.setTimeout(function () {
      if (emailEl) emailEl.focus();
    }, 40);
  }

  function closePopup() {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ks-notify-popup-open');
    document.body.classList.remove('ks-notify-popup-open');

    if (lastFocusedElement && lastFocusedElement.isConnected && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }

    lastFocusedElement = null;
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || popup.hidden) return;

    const focusable = Array.from(
      popup.querySelectorAll('button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return !element.hidden &&
        element.tabIndex >= 0 &&
        element.getAttribute('aria-hidden') !== 'true' &&
        element.getClientRects().length > 0;
    });

    if (!focusable.length) {
      event.preventDefault();
      popup.querySelector('.ks-notify-popup__dialog')?.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && (document.activeElement === first || !popup.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getSelectedOptionsMap(formEl) {
    const map = {};
    if (!formEl) return map;

    const checkedRadios = formEl.querySelectorAll('input[type="radio"]:checked');
    checkedRadios.forEach(function (input) {
      const key =
        input.dataset.index ||
        input.getAttribute('data-index') ||
        input.name ||
        '';

      if (key) {
        map[key] = normalizeValue(input.value);
      }
    });

    const selects = formEl.querySelectorAll('select');
    selects.forEach(function (select) {
      const key =
        select.dataset.index ||
        select.getAttribute('data-index') ||
        select.name ||
        '';

      if (key) {
        map[key] = normalizeValue(select.value);
      }
    });

    return map;
  }

  function getOptionPositionFromInput(input) {
    if (!input) return -1;

    const raw =
      input.dataset.index ||
      input.getAttribute('data-index') ||
      input.name ||
      '';

    const match = String(raw).match(/option(\d+)|options\[(\d+)\]/i);
    if (!match) return -1;

    const idx = parseInt(match[1] || match[2], 10);
    if (Number.isNaN(idx)) return -1;

    return idx - 1 >= 0 ? idx - 1 : idx;
  }

  function findVariantByOptions(product, optionValues) {
    if (!product || !product.variants || !optionValues) return null;

    return (
      product.variants.find(function (variant) {
        const variantOptions = variant.options || [];
        for (let i = 0; i < optionValues.length; i += 1) {
          if (normalizeValue(variantOptions[i]) !== normalizeValue(optionValues[i])) {
            return false;
          }
        }
        return true;
      }) || null
    );
  }

  async function resolveVariantFromDisabledLabel(labelEl) {
    const handle = getProductHandleFromUrl();
    const product = await getProductData(handle);
    const formEl = getProductForm();
    if (!product || !formEl || !labelEl) return null;

    let input = null;

    if (labelEl.hasAttribute('for')) {
      input = document.getElementById(labelEl.getAttribute('for'));
    }

    if (!input) {
      const parent = labelEl.closest('.variant-input');
      if (parent) {
        input = parent.querySelector('input');
      }
    }

    if (!input) return null;

    const optionPosition = getOptionPositionFromInput(input);
    if (optionPosition < 0) return null;

    const selectedMap = getSelectedOptionsMap(formEl);
    const optionValues = [];
    const optionCount = product.options ? product.options.length : 3;

    for (let i = 0; i < optionCount; i += 1) {
      const keyA = 'option' + (i + 1);
      const keyB = 'options[' + i + ']';

      if (i === optionPosition) {
        optionValues[i] = normalizeValue(input.value);
      } else {
        optionValues[i] = normalizeValue(selectedMap[keyA] || selectedMap[keyB] || '');
      }
    }

    return findVariantByOptions(product, optionValues);
  }

  function getVariantImageUrl(product, variant) {
    if (!product) return '';

    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }

    if (product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.src) return product.featured_image.src;
    }

    if (product.images && product.images.length) {
      return product.images[0];
    }

    return '';
  }

  async function openNotifyForVariant(variant) {
    const handle = getProductHandleFromUrl();
    const product = await getProductData(handle);
    if (!product) return;

    openPopup({
      title: product.title || '',
      handle: handle,
      productId: String(product.id || ''),
      variant: variant || null,
      image: getVariantImageUrl(product, variant)
    });
  }

  async function refreshNotifyState() {
    const handle = getProductHandleFromUrl();
    if (!handle) return;

    const product = await getProductData(handle);
    const formEl = getProductForm();
    const notifyButton = ensureNotifyButton();
    const hint = ensureNotifyHint();
    const atcButton = getAddToCartButton();
    const dynamicCheckout = getDynamicCheckout();

    prepareDisabledVariantLabels();

    if (!product || !formEl || !notifyButton) return;

    const currentVariantId = getCurrentVariantId();
    let selectedVariant =
      product.variants.find(function (variant) {
        return String(variant.id) === String(currentVariantId);
      }) || null;

    if (!selectedVariant && product.variants.length === 1) {
      selectedVariant = product.variants[0];
    }

    const isUnavailable = !!selectedVariant && selectedVariant.available === false;

    notifyButton.hidden = !isUnavailable;
    notifyButton.dataset.variantId = selectedVariant ? String(selectedVariant.id) : '';
    notifyButton.dataset.productId = String(product.id || '');
    notifyButton.dataset.productHandle = handle;

    if (hint) {
      hint.hidden = false;
    }

    if (dynamicCheckout) {
      dynamicCheckout.style.display = isUnavailable ? 'none' : '';
    }

    if (atcButton) {
      if (isUnavailable) {
        atcButton.classList.add('ks-atc-is-oos');
      } else {
        atcButton.classList.remove('ks-atc-is-oos');
      }
    }
  }

  function queueRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshNotifyState, 120);
  }

  function bindWatchers() {
    if (watchersBound) return;
    watchersBound = true;

    const formEl = getProductForm();
    if (formEl) {
      formEl.addEventListener('change', queueRefresh);
      formEl.addEventListener('input', queueRefresh);
      formEl.addEventListener('click', function () {
        window.setTimeout(queueRefresh, 50);
        window.setTimeout(queueRefresh, 180);
      });
    }

    document.addEventListener('variant:change', queueRefresh);
    document.addEventListener('variantChange', queueRefresh);
    document.addEventListener('product:variant-change', queueRefresh);
    document.addEventListener('product:variant:change', queueRefresh);
  }

  document.addEventListener(
    'click',
    async function (event) {
      const closeTrigger = event.target.closest('[data-ks-notify-close]');
      if (closeTrigger) {
        closePopup();
        return;
      }

      const inlineTrigger = event.target.closest('#ks-notify-inline-trigger');
      if (inlineTrigger) {
        event.preventDefault();

        const handle = inlineTrigger.dataset.productHandle || getProductHandleFromUrl();
        const product = await getProductData(handle);
        if (!product) return;

        const variantId = inlineTrigger.dataset.variantId || '';
        const variant =
          product.variants.find(function (item) {
            return String(item.id) === String(variantId);
          }) || null;

        await openNotifyForVariant(variant);
        return;
      }

      const disabledLabel = event.target.closest(disabledVariantSelector);

      if (disabledLabel) {
        event.preventDefault();
        event.stopPropagation();

        const variant = await resolveVariantFromDisabledLabel(disabledLabel);
        await openNotifyForVariant(variant);
      }
    },
    true
  );

  document.addEventListener('keydown', async function (event) {
    if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      event.preventDefault();
      closePopup();
      return;
    }

    if (popup.hidden && (event.key === 'Enter' || event.key === ' ')) {
      const disabledLabel = event.target.closest(disabledVariantSelector);

      if (disabledLabel) {
        event.preventDefault();
        const variant = await resolveVariantFromDisabledLabel(disabledLabel);
        await openNotifyForVariant(variant);
        return;
      }
    }

    trapFocus(event);
  });

  function init() {
    bindWatchers();
    queueRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
